import styled from "styled-components";

export const HeaderContainer = styled.div`
  padding: 0px 24px;
  overflow-x: auto;
  /* hide scroll */
  /* //IE and Edge
  -ms-overflow-style: none;
  // Firefox
  scrollbar-width: none;
  scrollbar-color: transparent transparent;
  &::-webkit-scrollbar {
    // Chrome, Safari, Opera
    display: none;
  } */

  /* hide scroll if it is not scrollable anymore */
`;
